<template>
  <div class="betgameeditbetview" id="betgameeditbetview">

    <NavigationBar>
      <template v-slot:left>
        <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack">
      </template>
      <template v-slot:center>
        {{ $t('menu.bet') }}
      </template>
    </NavigationBar>
    
    <form @submit.prevent="changeQuotesEnabled">
      <div class="input-container" style="margin-top: 16px;">
        <div>
          <div class="input-header">
            {{ $t('betgame_settings.betgame_enable_betquotes') }}
          </div>
          <div class="input-infotext">
            {{ $t('betgame_settings.betgame_enable_betquotes_text') }}
          </div>
          <div class="input-radio">
            <input v-model="quotes_enabled" value="true" type="radio" id="quotes_enabled_true" name="quotesenabled"/>
            <label for="quotes_enabled_true">{{ $t('yes') }}</label>
          </div>
          <div class="input-radio">
            <input v-model="quotes_enabled" value="false" type="radio" id="quotes_enabled_false" name="quotesenabled"/>
            <label for="quotes_enabled_false">{{ $t('no') }}</label>
          </div>
        </div>
        <div class="input-button-row">
          <button name="button" type="submit">
            {{ $t('button_save_text') }}
          </button>
        </div>
      </div>
    </form>
    
  </div>
</template>

<script>

import NavigationBar from './../components/NavigationBar'
import { TOAST_DURATION } from '../main'

export default {
  name: 'BetgameEditBetview',
  components: { NavigationBar },
  data () {
    return {
      betgame: null,
      quotes_enabled: true
    }
  },
  created () {
    this.betgame = this.$route.params.betgame
    if(this.betgame !== null && this.betgame !== undefined) {
      this.quotes_enabled = this.betgame.hide_ads ? 'false' : 'true'
    }
  },
  mounted () {
    if (this.betgame === null || this.betgame === undefined) {
      this.goBack()
    }
  },
  computed: {},
  methods: {
    updateBetgame (data) {
      this.$store.dispatch('patchBetgame', data)
      .then(() => {
        this.$toast.open({
          message: this.$i18n.t('save_changes_success'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'success'
        })
        this.goBack()
      })
      .catch(function (error) {
        this.$toast.open({
          message: this.$i18n.t('save_changes_error'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'error'
        })
      })
      .finally(function () {
      })
    },
    goBack () {
      this.$router.push('/betgameedit')
    },
    changeQuotesEnabled () {
      this.updateBetgame({ hide_ads: this.quotes_enabled === 'false'})
    }
  }
}
</script>

<style lang="scss" scoped>
.betgameeditbetview {

  form {
    padding-top: 16px;
  }

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
    margin-bottom: 26px;
  }
}


.grouped {
  margin-top: -16px;
}

.table-view {
  margin-bottom: 0;
}

.table-view-cell:last-child {
  border-bottom: 0;
}

.table-view-cell-label {
  color: rgba(var(--color-text-rgb), .48);
  font-weight: 400;
}
</style>
